// 9fbef606107a605d69c0edbcd8029e5d
import { USER_REDUCER_KEY } from '@tcp/core/src/constants/reducer.constants';
import { createSelector } from 'reselect';
import { fromJS } from 'immutable';
import { getLocalStorage } from '@tcp/core/src/utils/localStorageManagement';
import constants from '../User.constants';

export const getUserState = (state) => {
  return state[USER_REDUCER_KEY];
};

export const getPersonalDataState = (state) => {
  return state[USER_REDUCER_KEY]?.get('personalData');
};

/**
 * This will function will be triggered in store landing saga.
 * Checks for stores added from pick up store.
 */
export const getDefaultStoreDetails = (state) => {
  return state[USER_REDUCER_KEY].get('defaultStore') || null;
};

export const getUserGeoCoordinates = (state) => {
  return state[USER_REDUCER_KEY].get('geoLatLong');
};

export const getDefaultStoreData = (state) => {
  return (state[USER_REDUCER_KEY] && state[USER_REDUCER_KEY].get('defaultStore')) || null;
};

export const getDefaultAddress = createSelector(
  getPersonalDataState,
  (state) => state && state.get('defaultAddress')
);

export const getFavoriteStore = createSelector(getDefaultStoreData, (state) => {
  const basicInfo = state && state.basicInfo;
  if (basicInfo) {
    const { address } = basicInfo;
    return fromJS({
      name: basicInfo.storeName,
      phone: basicInfo.phone,
      address: address?.addressLine1,
      ...address,
    });
  }
  return null;
});

export const getAirmilesDataState = (state) => {
  return state[USER_REDUCER_KEY].get('airmiles');
};

export const getRewardsState = (state) => {
  return state[USER_REDUCER_KEY].get('rewards');
};

export const getIsRegisteredUserCallDone = (state) => {
  return state[USER_REDUCER_KEY].get('isRegisteredUserCallDone');
};

export const getSurveyState = (state) => {
  return state[USER_REDUCER_KEY].get('survey');
};

export const mprUserId = createSelector(
  getRewardsState,
  (state) => state && state.get('accountNumber')
);

export const getUserId = createSelector(
  getPersonalDataState,
  (state) => state && state.get('userId')
);

export const getIsGenericUser = (state) => {
  const personalData = state[USER_REDUCER_KEY].get('personalData');
  const userId = personalData && personalData.get('userId');
  return !userId || userId === constants.GENERIC_USER_ID;
};

export const getplccCardId = (state) => {
  const personalData = state[USER_REDUCER_KEY].get('personalData');
  return personalData && personalData.get('plccCardId');
};

export const getplccCardNumber = (state) => {
  const personalData = state[USER_REDUCER_KEY].get('personalData');
  return personalData && personalData.get('plccCardNumber');
};

export const getPhoneCountryCode = (state) => {
  const personalData = state[USER_REDUCER_KEY].get('personalData');
  return personalData && personalData.get('phoneCountryCode');
};

export const getUserLoggedInState = createSelector(
  getPersonalDataState,
  (state) => state && !state.get('isGuest')
);

export const getIsGuest = createSelector(
  getPersonalDataState,
  (personalData) => personalData && personalData.get('isGuest')
);

export const getSFLId = (state) => {
  const personalData = state[USER_REDUCER_KEY].get('personalData');
  return personalData && personalData.get('sflListId');
};

export const isPlccUser = createSelector(
  getPersonalDataState,
  (state) => state && state.get('isPlcc') === true
);

export const getIsPlccIC = createSelector(
  getPersonalDataState,
  (state) => state && state.get('isPlccIC') === true
);

export const getUserName = createSelector(
  getPersonalDataState,
  (state) => state && state.getIn(['contactInfo', 'firstName'])
);

export const getUserLastName = createSelector(
  getPersonalDataState,
  (state) => state && state.getIn(['contactInfo', 'lastName'])
);

export const getUserFullName = createSelector(getPersonalDataState, (state) => {
  return (
    state &&
    `${state.getIn(['contactInfo', 'firstName'], '')} ${state.getIn(
      ['contactInfo', 'lastName'],
      ''
    )}`
  );
});

export const getUserNickName = createSelector(getPersonalDataState, (state) => {
  return (
    state &&
    `${state.getIn(['contactInfo', 'firstName'], '')}__${state.getIn(
      ['contactInfo', 'lastName'],
      ''
    )}`
  );
});

export const getUserEmail = createSelector(
  getPersonalDataState,
  (state) =>
    state &&
    state.getIn(['contactInfo', 'emailAddress']) &&
    state.getIn(['contactInfo', 'emailAddress']).toLowerCase()
);

export const getUserPhoneNumber = createSelector(
  getPersonalDataState,
  (state) => state && state.getIn(['contactInfo', 'phoneNumber'])
);

export const getPointsToNextRewardState = createSelector(
  getRewardsState,
  (state) => state && state.get('rewardPointsToNextReward')
);

export const getCurrentPointsState = createSelector(
  getRewardsState,
  (state) => state && state.get('rewardPoints')
);

export const getTotalRewardsState = createSelector(
  getRewardsState,
  (state) => state && state.get('rewardDollars')
);

export const getUserContactInfo = createSelector(
  getPersonalDataState,
  (state) => state && state.get('contactInfo')
);

export const getMailingAddress = createSelector(
  getPersonalDataState,
  (state) => state && state.getIn(['contactInfo', 'profileAddress'])
);

export const getUserBirthday = createSelector(
  getPersonalDataState,
  (state) => state && state.get('userBirthday')
);

export const getProfileCompletion = createSelector(
  getPersonalDataState,
  (state) => state && state.get('profileCompletion')
);

export const getAnswersList = createSelector(
  getSurveyState,
  (state) => state && state.get('answers')
);

export const getDefaultStore = createSelector(
  getPersonalDataState,
  (state) => state && state.get('favStoreId')
);

export const getDefaultFavStore = createSelector(getDefaultStoreData, (favStore) => {
  try {
    if (favStore?.basicInfo?.id) return favStore;
    return JSON.parse(getLocalStorage('defaultStore')) || {};
  } catch (e) {
    return {};
  }
});

export const getAssociateId = createSelector(
  getPersonalDataState,
  (state) => state && state.get('associateId')
);

/**
 * @function getChildren
 * This function will return the children information from the redux store
 */
export const getChildren = createSelector(getUserState, (state) => state && state.get('children'));

export const getAirmilesDetails = createSelector(
  getAirmilesDataState,
  (state) => state && state.get('accountNumber')
);

export const getMyPlaceNumber = createSelector(
  getRewardsState,
  (state) => state && state.get('accountNumber')
);

export const getFavoriteStoreName = createSelector(
  getFavoriteStore,
  (state) => state && state.get('name')
);

export const getFavoriteStoreAddress = createSelector(
  getFavoriteStore,
  (state) => state && state.get('address')
);

export const getFavoriteStorePhone = createSelector(
  getFavoriteStore,
  (state) => state && state.get('phone')
);

export const getFavoriteStoreState = createSelector(
  getFavoriteStore,
  (state) => state && state.get('state')
);

export const getFavoriteStoreZipcode = createSelector(
  getFavoriteStore,
  (state) => state && state.get('zipCode')
);

export const getFavoriteStoreCity = createSelector(
  getFavoriteStore,
  (state) => state && state.get('city')
);

const userAddressData = (mailingAddress, addressTemp) => {
  return {
    addressId: addressTemp.get('addressId') || '',
    addressLine1: addressTemp.get('address1') || '',
    addressLine2: addressTemp.get('address2') || '',
    city: addressTemp.get('city') || '',
    country: addressTemp.get('country') || addressTemp.get('countryCode') || '',
    state: addressTemp.get('stateCode') || addressTemp.get('state') || '',
    zipCode: addressTemp.get('postalCode') || addressTemp.get('zipCode') || '',
    isComplete: mailingAddress.get('isComplete') || false,
  };
};

export const getProfileInfoTileData = createSelector(
  getUserContactInfo,
  getMailingAddress,
  getRewardsState,
  (personalInformation, mailingAddress, rewards) => {
    let firstName;
    let lastName;
    let emailAddress;
    let phoneNumber;
    let nickName;
    if (personalInformation) {
      firstName = personalInformation.get('firstName');
      lastName = personalInformation.get('lastName');
      phoneNumber = personalInformation.get('phoneNumber');
      emailAddress = personalInformation.get('emailAddress');
      nickName = mailingAddress && mailingAddress.get('addressKey');
    }
    const rewardsAccountNumber = rewards ? rewards.get('accountNumber') : null;
    const addressTemp = mailingAddress ? mailingAddress.get('address') : null;
    const address = addressTemp ? userAddressData(mailingAddress, addressTemp) : null;
    return {
      firstName,
      lastName,
      phoneNumber,
      nickName,
      emailAddress,
      rewardsAccountNumber,
      address,
    };
  }
);

export const getQuestionsList = createSelector(
  getSurveyState,
  (state) => state && state.get('questions')
);

export const getPercentageIncrement = () => ({
  percentageMailingAddress: 20,
  percentageUserSurvey: 20,
  percentageUserBirthday: 20,
  percentageFavStore: 20,
});

export const isRememberedUser = createSelector(
  getPersonalDataState,
  (state) => state && state.get('isRemembered')
);

export const getUserInfoFetchingState = createSelector(
  getUserState,
  (state) => state && state.get('isFetching')
);

export const getContextVenmoUserId = (state) => {
  const personalData = getPersonalDataState(state);
  return personalData && personalData.getIn(['contextAttributes', 'venmoUserId']);
};

export const getUserZipCode = createSelector(
  getMailingAddress,
  (state) => state && state.getIn(['address', 'zipCode'])
);

export const getChildrenName = (children) => {
  return children.get('name', '');
};

export const getChildrenGender = (children) => {
  const gender = children.get('gender', '01');
  return gender === '01' ? 'boy' : 'girl';
};

export const getChildBirthYear = (children) => {
  return children.get('birthYear', '');
};

export const getChildBirthMonth = (children) => {
  return children.get('birthMonth', '');
};

export const getSBPProfile = (children) => {
  return {
    name: getChildrenName(children),
    year: getChildBirthYear(children),
    month: getChildBirthMonth(children),
    gender: getChildrenGender(children).toUpperCase(),
  };
};

export const getUserNearStoreState = (state) => {
  return (state[USER_REDUCER_KEY] && state[USER_REDUCER_KEY].get('userNearStoreData')) || null;
};

export const getUserNearStore = createSelector(getUserNearStoreState, (state) => {
  return state;
});

export const getLoadingInProcess = createSelector(
  getUserState,
  (state) => state && state.get('isLoginInProcess')
);

export const getPerkState = (state) => {
  return state[USER_REDUCER_KEY].get('perk');
};

export const getTotalSpend = createSelector(
  getPerkState,
  (state) => state && state.get('totalSpend')
);

export const getCurrentPerkLevel = createSelector(
  getPerkState,
  (state) => state && state.get('currentPerkLevel')
);

export const getNextPerkLevel = createSelector(
  getPerkState,
  (state) => state && state.get('nextPerkLevel')
);

export const getSpendLeftForNextPerk = createSelector(
  getPerkState,
  (state) => state && state.get('spendLeftForNextPerk')
);

export const getBrandToggleInProgress = createSelector(
  getUserState,
  (state) => state && state.get('brandToggleInProgress')
);
